var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"h-[584px] sm:h-[636px] bg-darkgreen-50 !py-0"},[_c('BaseGridLayout',{staticClass:"h-full",attrs:{"size":"small"}},[_c('GptHubIntegration')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }